var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCancelWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.95 7.05a1 1 0 0 0 0 1.414L10.485 12 6.95 15.536a1 1 0 1 0 1.414 1.414l3.535-3.536 3.536 3.536a1 1 0 1 0 1.414-1.414L13.314 12l3.535-3.536a1 1 0 1 0-1.414-1.414l-3.536 3.536L8.364 7.05a1 1 0 0 0-1.414 0z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCancelWhite);
export default __webpack_public_path__ + "static/media/ic_cancel_white.8372b306630ae00e4e58413c08293e73.svg";
export { ForwardRef as ReactComponent };